import { useEffect, useState } from "react"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { useListaDeduplicacaoService, useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
// Icon

export const RecorteListasDeduplicacao = () => {
    // Redux State
    const { listasDeduplicacao } = useAppSelector((state) => state.listaDeduplicacao)
    const { openForm, editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Local State
    const [selectedListaDeduplicacao, setSelectedListaDeduplicacao] = useState<number[]>([])

    // Hooks
    const { setupListaDeduplicacao, resetListasDeduplicacao } = useListaDeduplicacaoService()
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    // Effects
    useEffect(() => {
        setupListaDeduplicacao()
    }, [setupListaDeduplicacao])

    useEffect(() => {
        resetListasDeduplicacao()
    }, [openForm, resetListasDeduplicacao])

    useEffect(() => {
        const listasDeduplicacaoSelecionadas = editRecorteExtracaoForm.fields.Filtros?.listasDeduplicacao || [];

        if (listasDeduplicacaoSelecionadas.length > 0) {
            setSelectedListaDeduplicacao(listasDeduplicacaoSelecionadas);
        } else {
            setSelectedListaDeduplicacao([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.listasDeduplicacao]);

    // Filter options to show only non-selected lists
    const filteredListasDeduplicacao = (listasDeduplicacao || []).filter((lista) =>
        !selectedListaDeduplicacao.includes(lista?.IdVelesGeoListaDeduplicacao || 0)
    );

    const handleListaDeduplicacaoSelectionChange = (value: any[]) => {
        const ids = (value || []).map((lista) => lista?.IdVelesGeoListaDeduplicacao || 0)
        setSelectedListaDeduplicacao(ids);

        if (ids.length > 0) {
            syncFilterWithForm({
                filtro: 'listasDeduplicacao',
                value: ids,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'listasDeduplicacao',
                formType: 'edit'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredListasDeduplicacao}
                    value={(listasDeduplicacao || []).filter(lista =>
                        selectedListaDeduplicacao.includes(lista?.IdVelesGeoListaDeduplicacao || 0)
                    )}
                    getOptionLabel={(option) => option?.Nome?.toUpperCase() || ''}
                    isOptionEqualToValue={(option, value) =>
                        option?.IdVelesGeoListaDeduplicacao === value?.IdVelesGeoListaDeduplicacao
                    }
                    sx={{
                        px: 2
                    }}
                    onChange={(event, value) => {
                        handleListaDeduplicacaoSelectionChange(value);
                    }}
                    noOptionsText={'Nenhuma lista encontrada'}
                    filterSelectedOptions={true}
                    disableCloseOnSelect
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Listas de Deduplicação"
                        />
                    )}
                />
            </Grid>
        </>
    )
}